import { BellIcon, BellOffIcon } from '@/components/icons'
import { setAlerts, useAlertStore } from '@/features/live/alerts'
import { cn } from '@/lib/utils'
import { toast } from '@/store/toast'

/** Sound and a desktop notification when a check arrives. Off until asked for. */
export function AlertsToggle({ compact }: { compact?: boolean }) {
  const enabled = useAlertStore((state) => state.enabled)
  const toggle = async () => {
    const on = await setAlerts(!enabled)
    if (!on) return
    const blocked = 'Notification' in window && Notification.permission === 'denied'
    toast.success('Alerts are on', blocked ? 'You will hear a tone. Desktop notifications are blocked in this browser.' : 'A tone and a notification when a check arrives.')
  }
  return (
    <button
      type="button"
      onClick={() => void toggle()}
      aria-pressed={enabled}
      title={enabled ? 'Alerts are on' : 'Alert me when a check arrives'}
      className={cn(
        'inline-flex h-9 shrink-0 items-center gap-2 rounded-field border text-[13px] font-medium transition-colors',
        compact ? 'w-9 justify-center' : 'px-3',
        enabled ? 'border-brand/30 bg-brand-soft text-brand' : 'border-line bg-surface text-ink-soft hover:bg-surface-muted',
      )}
    >
      {enabled ? <BellIcon className="h-4 w-4" /> : <BellOffIcon className="h-4 w-4" />}
      {!compact && (enabled ? 'Alerts on' : 'Alerts off')}
    </button>
  )
}
